// extracted by mini-css-extract-plugin
export default {"link":"Header_link__tiPUo"};